<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="运输状态" prop="transStatus">
            <dict-select
              v-model="formData.transStatus"
              placeholder="请选择运输状态"
              default
              :body="transStatusDictParams"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="运输状态说明">
            <el-input
              v-model="formData.transRemark"
              placeholder="请输入运输状态说明"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="上报经纬度">
            <el-col :span="20" style="padding:0px">
              <el-input
                v-model="formData.positionText"
                placeholder="请点击右边按钮查看地理位置"
                disabled
              >
              </el-input>
            </el-col>
            <el-col :span="2">
              <el-tooltip
                content="点击查看地理位置，获取中转站经纬度"
                placement="bottom-start"
              >
                <el-button
                  icon="el-icon-search"
                  circle
                  @click="openCoordPickerDialog()"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="上报终端">
            <el-select
              v-model="formData.upClient"
              placeholder="请选择上报终端"
              style="width:100%"
              clearable
            >
              <el-option label="PC端上报" value="PC" />
              <el-option label="微信上报" value="wechart" />
              <el-option label="设备上报" value="device" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="车牌号" prop="vehicleNo">
            <el-input v-model="formData.vehicleNo" placeholder="请输入车牌号">
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="司机姓名" prop="driverName">
            <el-input
              v-model="formData.driverName"
              placeholder="请输入司机姓名"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>

    <!-- region 地图 dialog -->
    <el-dialog
      v-if="openCoordPickerDialogOptions.visible"
      v-el-dialog-drag
      show-close
      visible
      append-to-body
      width="900px"
      :close-on-click-modal="false"
      :before-close="() => this.cancelCoordPickerDialog()"
    >
      <coord-picker
        style="height:450px"
        bottom="0px"
        :address="formData.transferStationAddress"
        :location="formData.positionText"
        @change="coordChange"
        ref="coordPicker"
      />
      <span slot="footer">
        <el-button size="small" @click="cancelCoordPickerDialog()"
          >取消</el-button
        >
        <el-button
          type="primary"
          size="small"
          v-if="!openCoordPickerDialogOptions.disabled"
          @click="saveCoord()"
          >保存</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backCoordDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backCoordDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="closeCoord()" size="small">不保存</el-button>
        <el-button @click="saveCoord()" type="primary" size="small"
          >保存</el-button
        >
      </span>
    </el-dialog>
    <!-- endRegion 地图 dialog -->
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    code: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      openCoordPickerDialogOptions: {
        visible: false,
      },
      transStatusDictParams: { type: 'transStatus' },
      backDialogVisible: false,
      backCoordDialogVisible: false,
      formData: { waybillCode: this.code },
      rules: {
        transStatus: [
          {
            required: true,
            message: '请选择运输状态',
            trigger: 'change',
          },
        ],
        vehicleNo: [
          {
            required: true,
            message: '请输入车牌号',
            trigger: 'blur',
          },
        ],
        driverName: [
          {
            required: true,
            message: '请输入司机姓名',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    coordChange(val) {
      this.positionText = val
    },
    openCoordPickerDialog() {
      this.openCoordPickerDialogOptions.visible = true
    },
    cancelCoordPickerDialog() {
      this.backCoordDialogVisible = true
    },
    saveCoord() {
      this.formData.positionText = this.positionText
      this.backCoordDialogVisible = false
      this.openCoordPickerDialogOptions.visible = false
    },
    closeCoord() {
      this.positionText = ''
      this.backCoordDialogVisible = false
      this.openCoordPickerDialogOptions.visible = false
    },
    getData() {
      if (!this.alarmRuleCode) return
      this.$api
        .sysAlarmRuleDetailApi({
          alarmRuleCode: this.alarmRuleCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      if (this.formData.positionText) {
        this.formData.transLongitude = this.formData.positionText.split(',')[0]
        this.formData.transLatitude = this.formData.positionText.split(',')[1]
      }
      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .carriageWaybillLogSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
